export function getQueryParamsManually(url:string) {
  const params: Record<string, string> = {};
  const queryStringStartIndex = url.indexOf('?');

  if (queryStringStartIndex === -1 || queryStringStartIndex === url.length - 1) {
    return params;
  }

  const queryString = url.substring(queryStringStartIndex + 1);

  const pairs = queryString.split('&');

  for (const pair of pairs) {
    if (!pair) {
      continue;
    }

    const parts = pair.split('=');
    const key = decodeURIComponent(parts[0] || ''); // Decodifica a chave, lida com chaves vazias
    const value = decodeURIComponent(parts.slice(1).join('=') || ''); // Decodifica o valor, lida com múltiplos '='

    params[key] = value;
  }

  return params;
}
